<template>
  <div class="iotcharging-container">
    <div class="search-layout">
      <el-form :model="queryInfo" size="medium" label-width="90px" inline>
        <el-form-item label="商户名称：" prop="searchTime">
          <el-select v-model="queryInfo.tenantId" :placeholder="$t('public.name1')" clearable>
            <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车型编号：" prop="cycleId">
          <el-input class="input-layout" v-model="queryInfo.cycleId" :placeholder="$t('public.name5')" clearable> </el-input>
        </el-form-item>
        <el-form-item label="车型名称：" prop="cycleName">
          <el-input class="input-layout" v-model="queryInfo.cycleName" :placeholder="$t('public.name5')" clearable> </el-input>
        </el-form-item>
        <el-form-item label="订单状态：" prop="status">
          <el-select v-model="queryInfo.status"  :placeholder="$t('public.name1')" clearable>
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单编号：" prop="orderNo">
          <el-input class="input-layout" v-model="queryInfo.orderNo" :placeholder="$t('public.name5')" clearable> </el-input>
        </el-form-item>
        <el-form-item label="订单时间：" prop="searchTime">
          <el-date-picker
            v-model="queryInfo.searchTime"
            type="datetimerange"
           value-format="yyyy-MM-dd HH:mm:ss"
            :range-separator="$t('public.name9')"
            :start-placeholder="$t('public.name10')"
            :end-placeholder="$t('public.name11')"
            align="left"
            @change="searchTimeclear"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item >
          <el-button type="primary" size="medium" @click="getOrderList">{{ $t('public.name3') }}</el-button>
          <el-button size="medium" @click="resetQuery">{{ $t('public.name4') }}</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="add-user">
      <el-button type="primary" icon="el-icon-plus" size="medium" @click="addOrder(null)">新增</el-button>
    </div>
    <el-table :data="orderList" :header-cell-style="{ fontSize: '14px', backgroundColor: '#f5f5f5', color: '#555' }" v-loading="tableLoading">
      <el-table-column label="订单编号" prop="orderNo" sortable></el-table-column>
      <el-table-column label="商户名称" prop="tenantName" sortable></el-table-column>
      <el-table-column label="车型编号" prop="cycleId" sortable></el-table-column>
      <el-table-column label="车型名称" prop="cycleName" sortable></el-table-column>
      <el-table-column label="数量" prop="num" sortable></el-table-column>
      <!-- <el-table-column label="单价" prop="price" sortable></el-table-column> -->
      <!-- <el-table-column label="其他费用" prop="other" sortable></el-table-column> -->
      <!-- <el-table-column label="总价" prop="totle" sortable></el-table-column> -->
      <el-table-column label="订单开始时间" prop="startTime" sortable></el-table-column>
      <el-table-column label="订单结束时间" prop="endTime" sortable></el-table-column>
      <el-table-column label="备注" prop="note" sortable></el-table-column>
      <el-table-column label="状态" prop="orderState" sortable></el-table-column>
      <el-table-column :label="$t('finance.name15')" width="188px" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="addOrder(scope.row)">编辑</el-button>
          <el-button type="text" @click="showStatusDialog(scope.row)">状态</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--分页-->
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryInfo.page"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="queryInfo.limit"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
    >
    </el-pagination>

    <el-dialog title="添加厂商购车订单" v-if="orderDialog" :visible.sync="orderDialog" :close-on-click-modal ="false" :before-close="close" width="440px">
      <el-form ref="orderFormRef" :model="orderInfo" :rules="orderInfoRules" label-width="130px">
        <el-form-item prop="tenantId" label="商户名称：">
          <el-select v-model="orderInfo.tenantId" :placeholder="$t('public.name1')" style="width:100%;">
            <el-option v-for="item in tenantOptions" :key="item.tenantId" :label="item.tenantName" :value="item.tenantId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="orderNo" label="订单编号：">
          <el-input v-model="orderInfo.orderNo" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="cycleId" label="车型名称：">
          <el-select v-model="orderInfo.cycleId" :placeholder="$t('public.name1')" style="width:100%;">
            <el-option v-for="item in modelOptions" :key="item.ebikeModelId" :label="item.ebikeModelName" :value="item.ebikeModelId"> </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="num" label="数量：">
          <el-input v-model="orderInfo.num" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <!-- <el-form-item prop="other" label="单价：">
          <el-input v-model="orderInfo.other" :placeholder="$t('public.name5')"></el-input>
        </el-form-item> -->
        <!-- <el-form-item prop="price" label="其他费用：">
          <el-input v-model="orderInfo.price" :placeholder="$t('public.name5')"></el-input>
        </el-form-item> -->
        <el-form-item prop="startTime" label="订单开始时间：">
          <el-date-picker style="width:100%;" v-model="orderInfo.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
        <el-form-item prop="endTime" label="订单结束时间：">
          <el-date-picker  style="width:100%;"  v-model="orderInfo.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
        </el-form-item>
        <el-form-item prop="note" label="备注：">
          <el-input v-model="orderInfo.note" :placeholder="$t('public.name5')"></el-input>
        </el-form-item>
        <el-form-item prop="file" label="电子合同上传：">
          <input v-model="orderInfo.file" style="display: none"   />
          <el-upload
            class="upload-demo"
            action=""
            :limit="1"
            :file-list="fileList"
            :on-remove="handleRemove"
            :http-request="
                (e) => {
                  handleUpLoadFile(e)
                }
              "
          >
            <el-button size="small" type="primary">点击上传</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitForm" :loading="loading">{{ $t('public.name13') }}</el-button>
        <el-button @click="close">{{ $t('public.name14') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog title="修改厂商购车订单状态" v-if="orderStatusDialog" :visible.sync="orderStatusDialog" :close-on-click-modal ="false" :before-close="close" width="388px">
      <el-form ref="orderStatusFormRef" :model="orderStatusInfo" :rules="orderStatusRules" label-width="100px">
        <el-form-item prop="status" label="订单状态：">
          <el-select v-model="orderStatusInfo.status" :placeholder="$t('public.name1')">
            <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value"> </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitStatusForm" :loading="loading">{{$t('public.name13')}}</el-button>
        <el-button @click="close">{{$t('public.name14')}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { orderList, orderAdd, orderEdit, orderStatus } from '@/api/finance.js'
import { tenantList, uploadFile } from '@/api/manage.js'
import { findEbikeModelPage } from '@/api/bike.js'
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  data() {
    return {
      queryInfo: {
        cycleId: '',
        cycleName: '',
        limit: 10,
        orderNo: '',
        page: 1,
        status: '',
        tenantId: '',
        searchTime: null
      },
      loading: false,
      fileList: [],
      statusOptions: [
        { value: 1, label: '进行中' }
      ],
      orderStatusInfo: {
        orderId: '',
        status: 0
      },
      orderStatusRules: {
        status: [
          {
            required: true,
            message: '请选择订单状态',
            trigger: 'blur'
          }
        ]
      },
      orderStatusDialog: false,
      modelOptions: [],
      tableLoading: false,
      orderDialog: false,
      orderList: [],
      total: 0,
      orderInfo: {
        cycleId: '',
        cycleName: '',
        endTime: '',
        file: '',
        note: '',
        num: '',
        orderNo: '',
        orderId: '',
        orderState: 0,
        other: '',
        price: '',
        startTime: '',
        tenantId: '',
        tenantName: '',
        totle: ''
      },
      tenantOptions: [],
      type: 1,
      orderInfoRules: {
        tenantId: [
          {
            required: true,
            message: '请选择商户',
            trigger: 'blur'
          }
        ],
        orderNo: [
          {
            required: true,
            message: '请输入订单编号',
            trigger: 'blur'
          }
        ],
        cycleId: [
          {
            required: true,
            message: '请选择车型名称',
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    this.getOrderList()
    this.getTenantList()
    this.getEbikeModelList()
  },
  mounted() {},
  methods: {
    resetQuery() {
      this.queryInfo = {
        cycleId: '',
        cycleName: '',
        limit: 10,
        orderNo: '',
        page: 1,
        status: '',
        searchTime: null,
        tenantId: ''
      }
      this.getOrderList()
    },
    getOrderList() {
      this.tableLoading = true
      const data = {
        page: this.queryInfo.page,
        limit: this.queryInfo.limit
      }
      if (this.queryInfo.tenantId) {
        data.tenantId = this.queryInfo.tenantId
      }
      if (this.queryInfo.cycleId) {
        data.cycleId = this.queryInfo.cycleId
      }
      if (this.queryInfo.cycleName) {
        data.cycleName = this.queryInfo.cycleName
      }
      if (this.queryInfo.orderNo) {
        data.orderNo = this.queryInfo.orderNo
      }
      if (this.queryInfo.status) {
        data.status = this.queryInfo.status
      }
      if (this.queryInfo.searchTime) {
        data.startTime = this.queryInfo.searchTime[0]
        data.endTime = this.queryInfo.searchTime[1]
      }
      orderList(data).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.orderList = res.data.list
          this.total = res.data.total
        }
      })
    },
    getEbikeModelList() {
      const data = {
        pageNumber: 1,
        pageSize: 10,
        tenantId: this.userinfo.tenantId
      }
      findEbikeModelPage(data).then(res => {
        this.tableLoading = false
        if (res.code === 200) {
          this.modelOptions = res.data.ebikeModelPage.records
        }
      })
    },
    addOrder(row) {
      if (row == null) {
        this.type = 1
      } else {
        this.type = 2
        this.fileList = [{ name: row.sysFile?.fileName, url: row.sysFile?.fileUrl }]
        this.orderInfo = {
          cycleId: row.cycleId,
          cycleName: row.cycleName,
          endTime: row.endTime,
          file: row.sysFile?.fileUrl || '',
          note: row.note,
          num: row.num,
          orderNo: row.orderNo,
          orderId: row.orderId,
          orderState: row.orderState,
          other: row.other,
          price: row.price,
          startTime: row.startTime,
          tenantId: row.tenantId,
          tenantName: row.tenantName,
          totle: row.totle
        }
      }
      this.orderDialog = true
    },
    getTenantList() {
      const data = {
        page: 1,
        limit: 500,
        tenantType: 2
      }

      tenantList(data)
        .then(res => {
          this.tenantOptions = res.data.list
        })
        .catch(() => {
          this.tenantOptions = []
        })
    },
    handleRemove(file, fileList) {
      this.orderInfo.file = ''
      this.fileList = []
    },
    handleUpLoadFile(param) {
      this.fileList = []
      const formData = new FormData()
      formData.append('multipart', param.file)
      const loading = this.$loading({
        lock: true,
        text: '上传中，请稍候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      uploadFile(formData)
        .then(res => {
          loading.close()
          if (res.code === 200) {
            this.orderInfo.file = res.data.fileId
            this.fileList = [{ name: res.data.fileName, url: res.data.fileUrl }]
            this.$message.success('上传成功')
          }
        })
        .catch(res => {
          this.fileList = []
          loading.close()
        })
    },
    submitForm() {
      this.$refs.orderFormRef.validate(valid => {
        if (valid) {
          this.loading = true
          if (this.type === 1) {
            orderAdd(this.orderInfo).then(res => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.getOrderList()
              }
            }).catch(() => {
              this.loading = false
            })
          } else {
            orderEdit(this.orderInfo).then(res => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.getOrderList()
              }
            }).catch(() => {
              this.loading = false
            })
          }
        } else {
          return false
        }
      })
    },
    showStatusDialog(row) {
      this.orderStatusInfo.orderId = row.orderId
      this.orderStatusDialog = true
    },
    submitStatusForm() {
      this.$refs.orderStatusFormRef.validate((valid) => {
        if (valid) {
          this.loading = true
          orderStatus(this.orderStatusInfo)
            .then((res) => {
              this.loading = false
              if (res.code === 200) {
                this.close()
                this.getOrderList()
              }
            })
            .catch(() => {
              this.loading = false
            })
        } else {
          return false
        }
      })
    },
    close() {
      this.orderDialog = false
      this.orderInfo = {
        cycleId: '',
        cycleName: '',
        endTime: '',
        file: '',
        note: '',
        num: '',
        orderNo: '',
        orderId: '',
        orderState: 0,
        other: '',
        price: '',
        startTime: '',
        tenantId: '',
        tenantName: '',
        totle: ''
      }
      this.fileList = []
      this.orderStatusInfo = {
        orderId: '',
        status: 0
      }
      this.orderStatusDialog = false
    },
    // 监听pagesizes的事件
    handleSizeChange(newSize) {
      this.queryInfo.limit = newSize
      this.getOrderList()
    },
    // 监听页码值改变事件
    handleCurrentChange(newPage) {
      this.queryInfo.page = newPage
      this.getOrderList()
    }
  }
}
</script>
<style lang="scss">
.el-dialog__body {
  display: flex;
  justify-content: center;
}
</style>
<style lang="scss" scoped>
.iotcharging-container {
  display: flex;
  flex-direction: column;
  .search-layout {
    display: flex;
    justify-content: space-between;
    .bt-layout {
      display: flex;
      flex-direction: row;
      height: 36px;
    }
  }
}
</style>
